import { render } from "./SimSearchFilters.vue?vue&type=template&id=4f5f6c52"
import script from "./SimSearchFilters.vue?vue&type=script&lang=js"
export * from "./SimSearchFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__